import brandSvg from './brand.svg';
import brandLightSvg from './brand-light.svg';
import brandPrimarySvg from './brand-primary.svg';

function Brand({ light, primary, ...props }) {
    if (light) return <img src={brandLightSvg} alt="Lupa" {...props} width={64} height={32} />;
    if (primary) return <img src={brandPrimarySvg} alt="Lupa" {...props} width={64} height={32} />;

    return <img src={brandSvg} alt="Lupa" {...props} width={64} height={32} />;
}

export default Brand;
